import script from "./AppBidInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBidInput.vue?vue&type=script&setup=true&lang=ts"

import "./AppBidInput.vue?vue&type=style&index=0&id=ad2e19fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2e19fe"]])

export default __exports__